import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ARService } from '../../ar.service';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { LOCIDModel } from '../../models/select-tdocid-locid.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { ArLedgerItemSelectComponent } from '../ar-ledger-item-select/ar-ledger-item-select.component';
import { DataArLedgerCredits } from '../../models/data-ar-ledger-credits';
import { Globals } from '../../../../globals';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { ConversionUtilities } from '../../../../utilities/conversion.utilities';
import { CurrencyPipe } from '@angular/common';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { TdoNoteAssociatedObject, TdoNoteSaveModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { MessagingService } from '../../../../services/messaging.service';
import { NotesService } from '../../../../services/notes.service';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { TemplatePortal } from '@angular/cdk/portal';
import { fromEvent, lastValueFrom, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ArDebitCreditReasonsComponent } from '../ar-debit-credit-reasons/ar-debit-credit-reasons.component';
import { DataARCreditDebitReasonModel } from '../../../../models/accountsReceivable/data-ar-credit-debit-reason.model';
import { MatRadioChange } from '@angular/material/radio';
import { CreditCardRefundRequest } from '../../../../models/accountsReceivable/credit-card-refund-request.model';
import { CreditCardRefundablePaymentModel } from '../../../../models/accountsReceivable/credit-card-refundable-payment.model';
import { MatTable } from '@angular/material/table';
import { ArIntegration_QuickBooks, Constants } from 'src/app/constants';
import { StaticDataService } from 'src/app/services/static-data.service';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { SavePaymentDistributionsModel } from '../../models/save-payment-distributions.model';
import { UiService } from 'src/app/services/ui.service';
import { DEBIT_ADJUSTMENT_REASON } from 'src/app/models/constants/debit-adjustment-reason.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';

@Component({
  standalone: false,
  selector: 'app-create-adjustment2',
  templateUrl: './create-adjustment2.component.html',
  styleUrls: ['./create-adjustment2.component.scss'],
})
export class CreateAdjustment2Component implements OnInit, OnDestroy {

  @ViewChild('editReasonContext') editReasonContextTemplate: TemplateRef<any>;
  @ViewChild('ccRefundTable') ccRefundTable: MatTable<any>;

  private destroyed = false;
  LOCID: number;
  isLoading: boolean = false;
  type: string = ''; // credit/debit
  title: string = '';
  ledgerItem: DataARLedgerListModel; // DataARLedgerModel;
  ledgerItemText: string = '';
  ledgerItems: DataARLedgerListModel[];
  ledgerItemsList: DataARLedgerListModel[];
  ledgerItemsCredits: DataARLedgerListModel[];
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
  enumARLedgerItemOriginTypeOverpay: string = '00000207-1000-0000-0000-000000000004';
  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumLedgerItemTypeCreditAdjustment: string = '00000078-1000-0000-0000-000000000007';
  enumLedgerItemTypeCreditAdjustmentInsurance: string = '00000078-1000-0000-0000-000000000008';
  enumLedgerItemTypeCreditCreatedFromPaymentVoid: string = '00000078-1000-0000-0000-000000000014';
  enumTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumTypeRefund: string = '00000078-1000-0000-0000-000000000005';
  enumTypeDebitAdjustment: string = '00000078-1000-0000-0000-000000000006';
  enumDebitAdjustmentActionDebitPatientAccount = '00000534-1000-0000-0000-000000000001';
  enumDebitAdjustmentActionIssueCheckInQuickBooks = '00000534-1000-0000-0000-000000000002';
  enumDebitAdjustmentActionIssueCreditCardRefund = '00000534-1000-0000-0000-000000000003';
  // PaymentDistributionName the backend assigns to undistributed payment credit rows in the CC refund grid
  ccRefundUndistributedCreditName = 'Undistributed Credit';
  ccRefundUnappliedBalanceName = 'Unapplied Payment Balance';
  emptyGuid = '00000000-0000-0000-0000-000000000000';
  enumARReasonCreditAdjustmentID: string;
  enumARReasonDebitAdjustmentID: string;
  enumARReasonAdjustmentID: string;
  enumARReasonAdjustment: string;
  paymentIDToVoid: string;
  paymentToVoid: DataARLedgerListModel;
  payment: DataARPaymentModel;
  adjustmentNote: string = '';

  arAccounts: CfgARAccountModel[] = [];
  private arAccountsRequestId = 0;
  locations: LOCIDModel[] = [];
  enumDebitAdjustmentActions: EnumValidValueItemModel[] = [];
  creditDebitReasons: DataARCreditDebitReasonModel[] = [];
  paymentRecordsCC: CreditCardRefundablePaymentModel[] = [];

  selectedARAccount: CfgARAccountModel;
  selectedLocation: LOCIDModel;
  selectedDate: Date = new Date();
  selectedLedgerItem: DataARLedgerListModel;
  selectedEnumDebitAdjustmentAction: EnumValidValueItemModel;
  selectedCreditDebitReason: DataARCreditDebitReasonModel;

  TZID: string = '';
  tzOffsetMins: number = 0;

  enumCreditDebitTypeCredit: string = '00000538-1000-0000-0000-000000000001';
  enumCreditDebitTypeDebit: string = '00000538-1000-0000-0000-000000000002';

  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  footerMessage: string = '';
  private lastReasonWasNSF = false;
  paymentToRefund: CreditCardRefundablePaymentModel;
  isDoctorARQuickBooksIntegration: boolean = false;

  CCRefundTableColumns: string[] = ['PaymentTransactionDate', 'Description', 'ARAccountName', 'PaymentAmount', 'AmountAvailable', 'Refund', 'PaymentID'];

  requiredNotes: boolean = false;
  requiredLedgerItem: boolean;
  requiredLocation: boolean;
  requiredARAccount: boolean;
  requiredAmount: boolean;
  CCRefundAmountToRefund: number = 0;

  constructor(
    public dialogRef: MatDialogRef<CreateAdjustment2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    //private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globals: Globals,
    private cp: CurrencyPipe,
    private messagingService: MessagingService,
    private notesService: NotesService,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private currencyPipe: CurrencyPipe,
    public uiService: UiService,
    private readonly staticDataService: StaticDataService,
    private readonly changeDetection: ChangeDetectorRef,
  ) { }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.LOCID = Number.parseInt(localStorage.getItem('LOCID'));
    this.type = this.data.type;
    this.ledgerItems = this.data.dataLedgerItems;
    this.ledgerItemsList = this.data.dataLedgerItems;

    if (this.data.paymentLedgerItemToVoid) {
      this.paymentToVoid = this.data.paymentLedgerItemToVoid;
    }

    this.ledgerItem = new DataARLedgerListModel();
    this.ledgerItem.PatientId = this.data.PatientId;
    this.ledgerItem.Amount = 0;
    this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
    this.ledgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;

    if (this.type === 'credit') {
      this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeCredit;
      this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeOverpay;
    }
    else {
      // debit
      this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeDebitAdjustment;
      if (this.selectedLedgerItem) {
        if (this.selectedLedgerItem.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient) {
          this.ledgerItem.enumARLedgerItemOriginTypeID = this.selectedLedgerItem.enumARLedgerItemOriginTypeID;
        }
      }
    }

    // credits
    this.ledgerItemsCredits = this.ledgerItems.filter(a => a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding &&
      (a.enumARLedgerItemTypeID === this.enumLedgerItemTypeCreditAdjustment
        || a.enumARLedgerItemTypeID === this.enumLedgerItemTypeCreditAdjustmentInsurance)
      && a.Amount > 0);
    this.ledgerItemsCredits.forEach(a => {
      a.RefundAmount = 0;
      a.RefundChecked = false;
    });

    // title
    if (this.type === 'debit') {
      this.title = 'Debit Adjustment';
    }
    else if (this.type === 'credit') {
      this.title = 'Credit Adjustment';
    }
    else if (this.type === 'void-payment') {
      this.title = 'Void Payment Transaction';
    }
    else if (this.type === 'checkreversal') {
      this.title = 'Check Payment Reversal';
    }

    this.setRequiredFields();
    this.init();
  }

  setRequiredFields() {
    // flags depend on the selected debit action, so start clean each time it changes
    this.requiredLocation = false;
    this.requiredARAccount = false;
    this.requiredLedgerItem = false;
    this.requiredNotes = false;

    if (this.type === 'credit') {
      this.requiredLocation = true;
      this.requiredARAccount = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction?.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      this.requiredLocation = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction?.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      this.requiredLocation = true;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction?.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount) {
      this.requiredLocation = true;
      this.requiredARAccount = true;
      this.requiredLedgerItem = true;
    }
    else if (this.type === 'void-payment' || this.type === 'checkreversal') {
      this.requiredNotes = true;
    }
  }
  async init() {
    const promises: any[] = [
      this.getLocations(),
      this.getAllDoctorARLocations(),
      this.getEnumValidValueItemsByValidValueName('enumDebitAdjustmentAction'),
      this.arService.getDebitCreditReasons(this.LOCID).toPromise(),
      this.arService.getCCPaymentRecordsForPatient(this.data.PatientId).toPromise()
    ];

    if (this.paymentToVoid) {
      promises.push(this.arService.getPaymentRecordByID(this.paymentToVoid.PaymetnID).toPromise());
      promises.push(this.arService.getAllARAccounts().toPromise());
    }

    try {
      const results: any[] = await Promise.all(promises);
      this.locations = results[0];
      this.arAccounts = results[1];
      this.enumDebitAdjustmentActions = results[2];
      this.creditDebitReasons = results[3];
      this.paymentRecordsCC = results[4];

      this.selectedEnumDebitAdjustmentAction = this.enumDebitAdjustmentActions[0];
      this.setRequiredFields();


      if (this.paymentToVoid) {
        // voiding a payment
        this.payment = results[5];
        this.arAccounts = results[6];
        this.ledgerItem = this.paymentToVoid;
        this.selectedLocation = this.locations.find(a => Number(a.LOCID) === this.ledgerItem.LOCID);
        this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID === this.payment.DepositARAccountID);
        this.ledgerItemText = this.ledgerItem.Description;
        // trigger change event for amount
        this.raiseCustomEvent2('debitAmount', this.ledgerItem.Amount);
      }

      // filter creditDebitReasons by type
      this.filterCreditDebitReasonsByType();

      this.isLoading = false;
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
      this.isLoading = false;
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
  }

  filterCreditDebitReasonsByType() {
    if (this.type === 'debit') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeDebit);
    }
    else if (this.type === 'credit') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeCredit);
    }
    else if (this.type === 'void-payment') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumCreditDebitTypeID === this.enumCreditDebitTypeDebit);
    }
    else if (this.type === 'checkreversal') {
      this.creditDebitReasons = this.creditDebitReasons.filter(a => a.enumARReasonDebitAdjustmentID === DEBIT_ADJUSTMENT_REASON.NSFCheckReversal);
      this.selectedCreditDebitReason = this.creditDebitReasons.find(a => a.enumARReasonDebitAdjustmentID === DEBIT_ADJUSTMENT_REASON.NSFCheckReversal);
    }
    this.lastReasonWasNSF = this.isNSFReason();
  }

  async onLocationChange(): Promise<boolean> {
    this.selectedARAccount = null;
    try {
      const applied = await this.loadARAccounts(this.getAllDoctorARLocationsByLOCID(Number.parseInt(this.selectedLocation.LOCID)));
      if (applied) {
        this.refreshSystemsIntegration();
      }
      return applied;
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
      return false;
    }
    finally {
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
  }

  // only the latest AR account load may apply; a late response must not replace a newer location's list
  private async loadARAccounts(request: Promise<unknown>): Promise<boolean> {
    const requestId = ++this.arAccountsRequestId;
    const accounts = await request as CfgARAccountModel[];
    if (requestId !== this.arAccountsRequestId) {
      return false;
    }
    this.arAccounts = accounts;
    return true;
  }


  async save() {
    this.footerMessage = '';
    if (!this.validateAmount()) {
      return;
    }
    try {
      this.isLoading = true;
      let creditItemDoctorARLocId = this.selectedLedgerItem?.DoctorARLocId ?? null;
      if (!creditItemDoctorARLocId
        && this.selectedLedgerItem?.enumARLedgerItemTypeID === this.enumLedgerItemTypeCreditAdjustment
        && this.selectedLedgerItem?.PaymetnID) {
        // Older "Undistributed payment credit" rows can be missing DoctorARLocId.
        // Recover it from another ledger item tied to the same payment.
        const relatedItem = this.ledgerItems.find(a =>
          a.PaymetnID === this.selectedLedgerItem.PaymetnID && a.DoctorARLocId);
        creditItemDoctorARLocId = relatedItem?.DoctorARLocId ?? null;
      }

      const refundDoctorARLocId = this.isValidGuid(this.paymentToRefund?.DoctorARLocId) ? this.paymentToRefund.DoctorARLocId : null;
      const refundARAccount = refundDoctorARLocId
        ? this.arAccounts.find(a => a.DoctorARLocId === refundDoctorARLocId)
        : null;

      // a doctor picked in the modal only applies while undistributed credit is being refunded
      const refundOverrideAccount = this.requiresRefundDoctorSelection() ? this.selectedARAccount : null;

      if (this.isCreditCardRefundAction()) {
        // the picked doctor wins; otherwise inherit the refunded payment's doctor
        const doctorARAccount = refundOverrideAccount ?? refundARAccount;
        this.ledgerItem.DoctorARLocId = refundOverrideAccount?.DoctorARLocId ?? refundDoctorARLocId;
        this.ledgerItem.ARAccountID = doctorARAccount?.ARAccountID ?? null;
      }
      else {
        this.ledgerItem.DoctorARLocId = creditItemDoctorARLocId ?? this.selectedARAccount?.DoctorARLocId ?? refundDoctorARLocId;
        this.ledgerItem.ARAccountID = this.selectedLedgerItem?.ARAccountID ?? this.selectedARAccount?.ARAccountID ?? refundARAccount?.ARAccountID ?? null;
      }
      this.ledgerItem.ParentLedgerID = this.selectedLedgerItem ? this.selectedLedgerItem.LedgerID : null;

      this.ledgerItem.Description = this.selectedCreditDebitReason.Reason;
      this.ledgerItem.CreditDebitReasonID = this.selectedCreditDebitReason.CreditDebitReasonID;
      if (this.ledgerItemText) {
        this.ledgerItem.Description += ' | ' + this.ledgerItemText;
      }

      this.ledgerItem.PostDate = this.selectedDate;
      console.log("Save Date:", this.ledgerItem.PostDate);
      this.ledgerItem.LOCID = Number.parseInt(this.selectedLocation.LOCID);
      this.ledgerItem.enumARLedgerItemOriginTypeID = this.selectedLedgerItem ? this.selectedLedgerItem.enumARLedgerItemOriginTypeID : null;
      if (this.type !== 'void-payment') {
        const referenceAccount = this.isCreditCardRefundAction()
          ? (refundOverrideAccount ?? refundARAccount)
          : (this.selectedARAccount ?? refundARAccount);
        if (referenceAccount) {
          this.ledgerItem.Reference = referenceAccount.AccountName;
        }
      }

      const currDate = new Date();
      console.log("Save Date system:", currDate);
      const newDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate(), currDate.getHours(), currDate.getMinutes(), currDate.getSeconds());
      this.ledgerItem.PostDate = newDate;
      console.log("Save Date calculated:", this.ledgerItem.PostDate);
      if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
        this.ledgerItem.PaymetnID = this.paymentToRefund ? this.paymentToRefund.PaymentID : null;
        this.ledgerItem.enumCurrencyID = this.paymentToRefund ? this.paymentToRefund.enumCurrencyID : null;
        this.ledgerItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
        this.ledgerItem.enumARLedgerItemTypeID = this.enumTypeRefund;
        this.ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeTransaction;
      }
      if (this.type === 'checkreversal') {
        // handle payment voiding tasks
        // console.log("save checkreversal");
        // console.log("save this.paymentToVoid.PaymetnID,", this.paymentToVoid.PaymetnID);
        // console.log("save selectedCreditDebitReason.enumARReasonDebitAdjustmentID", this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID);
        this.arService.checkReversal(this.paymentToVoid.PaymetnID, this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID, this.selectedCreditDebitReason.CreditDebitReasonID)
          .subscribe({
            next: (response) => {
            console.log("checkReversal response", response);
            if (response === true) {

              // record reason in note
              if (this.adjustmentNote !== '') {
                this.createNoteForLedgerItem();
              }
              this.isLoading = false;
              this.displayMessage('Check Reversed.', 'Success');
              this.close(true);
            }
            else {
              this.displayMessage('Error trying to reverse check: ' + response, 'Error');
              this.isLoading = false;
            }
            
            if (!this.destroyed) { this.changeDetection.markForCheck(); }
          },
          error: (error) => {
              console.log(error);
              this.displayMessage('Error trying to reverse check, please try again later.', 'Error');
              this.isLoading = false;
              if (!this.destroyed) { this.changeDetection.markForCheck(); }
            },          
          complete: () => {
            this.isLoading = false;
            if (!this.destroyed) { this.changeDetection.markForCheck(); }
          }
        });
      }
      else if (this.type === 'void-payment') {
        // handle payment voiding tasks
        this.arService.voidPayment(this.paymentToVoid.PaymetnID, this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID, this.selectedCreditDebitReason.CreditDebitReasonID)
          .subscribe({
            next: (response) => {
            console.log(response);

            // record reason in note
            if (this.adjustmentNote !== '') {
              this.createNoteForLedgerItem();
            }
            this.isLoading = false;
            this.displayMessage('Payment Voided', 'Success');
            this.close(true);
            if (!this.destroyed) { this.changeDetection.markForCheck(); }
          },
            error: (error) => {
              console.log(error);
              this.displayMessage('Error trying to void payment, please try again later.', 'Error');
              this.isLoading = false;
              if (!this.destroyed) { this.changeDetection.markForCheck(); }
            },
            complete: () => {
              this.isLoading = false;
              if (!this.destroyed) { this.changeDetection.markForCheck(); }
            }
          });      
      }
      else {

        //refund text:
        if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund)
          this.ledgerItem.Description = 'CC Refund: ' + this.ledgerItem.Description;

        //create ledger item
        const ledgerReturn: DataARLedgerModel = await lastValueFrom(this.arService.saveLedgerItem(this.ledgerItem));
        this.ledgerItem.LedgerID = ledgerReturn.LedgerID;
        if (this.adjustmentNote !== '') {
          // this.saveNote();
          this.createNoteForLedgerItem();
        }

        // if credit, applied as a payment Distribution, mirroring ar-payment createCreditForUndistributedPayment()
        if (this.type === 'credit') {
          await this.createCreditForUndistributedPayment();
        }       
        // if debit and quickbooks was selected
        if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {

           // if debit adjustment, and if insurance overpay credit chosen as ledger item reference..
        const creditObj = new DataArLedgerCredits();
        creditObj.PatientID = this.data.PatientId;
        creditObj.enumARLedgerItemOriginType = this.enumARLedgerItemOriginTypeInsurance;
        creditObj.enumARLedgerItemType = this.enumLedgerItemTypeCreditAdjustmentInsurance;
        creditObj.Amount = this.ledgerItem.Amount;
        
          this.ledgerItemsCredits.forEach(a => {
            if (a.RefundChecked && a.RefundAmount > 0) {
              creditObj.ledgerItems.push(a);
            }
          });
          await lastValueFrom(this.arService.resolveLedgerCreditItems2(creditObj)).then(() => {
            if (!this.destroyed) { this.changeDetection.detectChanges(); }
          });
        }


        this.displayMessage('Adjustment created', 'Success');

        if (this.type === 'debit') {
          if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
            const refundRequest: CreditCardRefundRequest = {
              PaymentID: this.paymentToRefund.PaymentID,
              Amount: this.ledgerItem.Amount,
              LedgerItemID: ledgerReturn.LedgerID,
            };
            this.arService.requestCreditCardRefund(refundRequest).subscribe(async (response) => {
              if (response.Success) {
                this.displayMessage('Credit Card Refund Successful', 'Success');

                // need to update affected payment transactions
                const paymentsRefunded = this.paymentRecordsCC.filter(a => a.IsDistribution && a.Refund > 0);
                paymentsRefunded.forEach(a => {
                  a.ReasonID = this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID;
                });
                console.log('updateRefundedPaymentDistributions entered');
                await this.updateRefundedPaymentDistributions(this.paymentToRefund.PaymentID, paymentsRefunded).then(() => {
                  console.log('updateRefundedPaymentDistributions complete');
                  this.isLoading = false;
                  this.close(this.ledgerItem);
                });
              }
              else {
                this.displayMessage('Credit Card Refund Failed', 'Error');
                this.footerMessage = `Credit Card Refund Failed: ${response.Message}`;
                this.isLoading = false;
              }
            }, (error) => {
              console.log(error);
              this.displayMessage(`Credit Card Refund Error: ${error.Message ?? error.error.ExceptionMessage}`, 'Error');
              this.footerMessage = `Credit Card Refund Error: ${error.Message ?? error.error.ExceptionMessage}`;

              this.isLoading = false;

            }
            );

          }
          else if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
            this.displayMessage('Quickbooks not yet implemented', 'Success');
            this.isLoading = false;
            this.close(true);
          }
          else {
            this.isLoading = false;
            this.close(this.ledgerItem);
          }
        }
        else {
          this.isLoading = false;
          this.close(true);
        }
      }

    } catch (err) {
      console.log(err);
      this.isLoading = false;
      this.displayMessage('Something went wrong', 'Error');
      this.close(false);
    }

  }

  async createCreditForUndistributedPayment() {
    try {
      // Step 1: create a CreditAdjustment (type 07) as the patient-usable credit.
      // Must be type 07, not type 01 — the backend voids type 01 immediately when used as a payment source.
      const creditAdjItem = new DataARLedgerModel();
      creditAdjItem.PatientId = this.data.PatientId;
      creditAdjItem.Amount = this.ledgerItem.Amount;
      creditAdjItem.enumARLedgerItemTypeID = this.enumLedgerItemTypeCreditAdjustment;
      creditAdjItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
      creditAdjItem.enumLedgerItemStatusID = LEDGER_ITEM_STATUS.Outstanding;
      creditAdjItem.DoctorARLocId = this.ledgerItem.DoctorARLocId;
      creditAdjItem.ARAccountID = this.ledgerItem.ARAccountID;
      creditAdjItem.ParentLedgerID = this.ledgerItem.LedgerID;
      creditAdjItem.CreditDebitReasonID = this.ledgerItem.CreditDebitReasonID;
      creditAdjItem.LOCID = this.ledgerItem.LOCID;
      creditAdjItem.Reference = 'Credit from credit adjustment';
      const currDate = new Date();
      creditAdjItem.PostDate = new Date(
        this.selectedDate.getFullYear(), this.selectedDate.getMonth(), this.selectedDate.getDate(),
        currDate.getHours(), currDate.getMinutes(), currDate.getSeconds()
      );

      const savedCreditAdj = await lastValueFrom(this.arService.saveLedgerItem(creditAdjItem));

      // Step 2: apply the type 07 CreditAdjustment — same flow ar-payment uses when applying a patient credit
      const createPayment = new CreatePaymentModel();
      createPayment.datePostPayment = new Date();
      createPayment.dateReceivedPayment = new Date();
      createPayment.Description = 'Credit from credit adjustment';
      createPayment.PatientID = this.data.PatientId;
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.ApplyCredit;
      createPayment.PaymentSourceObjectID = savedCreditAdj.LedgerID;
      createPayment.enumARPayementCCTypeID = null;
      createPayment.enumARPayementETypeID = null;
      createPayment.enumARPayementTypeID = EnumARPaymentType.InternalCredit;
      createPayment.paymentAmount = this.ledgerItem.Amount;
      createPayment.PaymentFromContactID = null;
      createPayment.PaymentFrom = null;
      createPayment.LOCID = this.globals.LOCID;

      const newPayment = await lastValueFrom(
        this.arService.createDataARPaymentRecord(createPayment)
      ) as unknown as DataARPaymentModel;

      // Step 3: distribute to outstanding patient debit items and void the type 07 item
      const freshLedger = await lastValueFrom(
        this.arService.getLedgerForPatient2(this.data.PatientId)
      );

      let remaining = this.ledgerItem.Amount;
      let outstandingDebits: DataARLedgerListModel[];

      if (this.selectedLedgerItem) {
        // apply only to the transaction the credit was created against
        const target = freshLedger.find(a => a.LedgerID === this.selectedLedgerItem.LedgerID);
        outstandingDebits = target ? [target] : [];
      } else {
        outstandingDebits = freshLedger.filter(a =>
          a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit &&
          a.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Outstanding &&
          a.AmountDuePatient > 0
        );
      }

      for (const item of outstandingDebits) {
        if (remaining <= 0) break;
        item.ApplyPayment = Math.min(remaining, item.AmountDuePatient);
        remaining -= item.ApplyPayment;
      }

      const distributions = outstandingDebits.filter(a => a.ApplyPayment > 0);
      if (distributions.length === 0) {
        this.displayMessage('Credit adjustment created, but there was nothing outstanding to apply it to.', 'Warning');
        return;
      }

      const saveDistModel = new SavePaymentDistributionsModel();
      saveDistModel.PaymentID = newPayment.PaymetnID;
      saveDistModel.ClientPostDate = new Date();
      saveDistModel.dataARLedgerItems = distributions;
      saveDistModel.LOCID = parseInt(this.globals.LOCID);
      saveDistModel.DoctorARLocID = this.ledgerItem.DoctorARLocId;
      saveDistModel.LedgerItemToVoid = savedCreditAdj.LedgerID;

      await lastValueFrom(this.arService.savePaymentDistributions(saveDistModel));
    } catch (err) {
      console.error('Error applying credit from adjustment', err);
      this.displayMessage('Credit adjustment saved but could not be auto-applied.', 'Warning');
    }
  }

  async updateRefundedPaymentDistributions(PaymentID: string, ccRefundRecords: CreditCardRefundablePaymentModel[]) {
    const promises: any[] = [
      this.arService.updateCreditCardRefundPaymentDistributions(PaymentID, ccRefundRecords).toPromise(),
    ];

    try {
      await Promise.all(promises);
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  displayMessage(message, type) {
    this.uiService.displayMessage(type, message);
  }


  getLocations() {
    return this.arService.getLocations().toPromise();
  }

  getAllDoctorARLocations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocations()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllDoctorARLocationsByLOCID(LOCID: number) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocationsByLOCID(LOCID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getDoctorARLocationIntegration(LOCID: number, DoctorId: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getDoctorARLocationIntegration(LOCID, DoctorId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string) {
    return this.staticDataService.getEnumValidValueItemsByValidValueName(ValidValueName).toPromise();
  }

  onPaymentRefundSelected(event: MatRadioChange, payment: CreditCardRefundablePaymentModel) {
    this.paymentToRefund = payment;
  }

  async openChooseLedgerItemWindow() {
    // console.log("CreateAdjustment2Component openChooseLedgerItemWindow selectedCreditDebitReason", this.selectedCreditDebitReason);
    // console.log("CreateAdjustment2Component openChooseLedgerItemWindow type", this.type);
    const type = this.isNSFReason() ? 'checkreversal' : this.type;
    // console.log("CreateAdjustment2Component openChooseLedgerItemWindow new type", type);
    const dialogRef = this.dialog.open(ArLedgerItemSelectComponent, {
      panelClass: 'dialog',
      autoFocus: false,
      data: {
        dataLedgerItems: this.ledgerItemsList.filter(
          a => a.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void),
        type: type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedLedgerItem = result;
        this.ledgerItemText = this.selectedLedgerItem.Description;

        // set defaults
        this.selectedLocation = this.locations.find(a => Number(a.LOCID) === this.selectedLedgerItem.LOCID);

        // reload ar accounts list and set selected
        this.LoadDefaultARAccountForLedgerItem();
      }
      
      if (!this.destroyed) { this.changeDetection.detectChanges(); }
    }, err => {
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    });
  }

  async LoadDefaultARAccountForLedgerItem() {
    const ledgerItem = this.selectedLedgerItem;
    const applied = await this.onLocationChange();
    // selection may have been cleared or replaced while accounts were loading
    if (!applied || !ledgerItem || this.selectedLedgerItem !== ledgerItem) {
      return;
    }
    this.selectedARAccount = this.arAccounts.find(a => a.DoctorARLocId === ledgerItem.DoctorARLocId);
    if (!this.destroyed) { this.changeDetection.markForCheck(); }
  }

  defaultToCurrentLocation() {
    this.locations.forEach(a => {
      if (a.LOCID === this.globals.LOCID) {
        this.selectedLocation = a;
      }
    });
  }

  async debitActionChanged() {
    if (this.ledgerItem) {
      this.ledgerItem.Amount = 0;
    }
    // each action picks its own ledger item, location and AR account; drop the previous selection
    this.selectedLedgerItem = null;
    this.selectedARAccount = null;
    this.selectedLocation = null;
    this.ledgerItemText = '';
    this.ledgerItemsCredits?.forEach(a => {
      a.RefundChecked = false;
      a.RefundAmount = 0;
    });
    this.paymentRecordsCC?.forEach(a => {
      a.isChecked = false;
      a.Refund = 0;
    });
    this.paymentToRefund = null;
    this.CCRefundAmountToRefund = 0;
    this.isDoctorARQuickBooksIntegration = false;
    this.footerMessage = '';
    if (this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      this.defaultToCurrentLocation();
      this.updateTotalRefundAmount();
    }
    this.setRequiredFields();

    // the AR account list may still be filtered to the previous location
    try {
      await this.loadARAccounts(this.getAllDoctorARLocations());
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
    finally {
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
  }

  private getCreditCardRefundValidationMessage(): string | null {
    if (this.type !== 'debit' || this.selectedEnumDebitAdjustmentAction?.ValidValueItemId !== this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      return null;
    }
    if (!this.selectedCreditDebitReason || !this.selectedDate || !this.ledgerItem?.Amount
      || !this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID || !this.selectedLocation) {
      return null;
    }
    if (this.paymentToRefund?.AvailableAmount < this.CCRefundAmountToRefund) {
      return `Refund amount exceeds available balance in payment`;
    }
    for (const a of this.paymentRecordsCC) {
      if (a.IsDistribution && this.CCRefundIsParentChecked(a.PaymentID)) {
        if (this.getNumber(a.Refund) > this.getCCRefundRowMax(a)) {
          return `Refund amount cannot be greater than available amount`;
        }
      }
    }
    if (this.requiresRefundDoctorSelection() && !this.selectedARAccount?.DoctorARLocId) {
      return `Select a doctor for the undistributed credit refund`;
    }
    return null;
  }

  private isCreditCardRefundAction(): boolean {
    return this.type === 'debit' && this.selectedEnumDebitAdjustmentAction?.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund;
  }

  private isValidGuid(id: string): boolean {
    return !!id && id !== this.emptyGuid;
  }

  // the API sends each refundable row's available amount; a row without one has nothing to refund
  getCCRefundRowMax(row: CreditCardRefundablePaymentModel): number {
    return this.getNumber(row.AvailableAmount ?? 0);
  }

  isUndistributedCreditRow(row: CreditCardRefundablePaymentModel): boolean {
    // the unapplied payment balance has no doctor of its own either
    return !!row?.IsDistribution && (row.PaymentDistributionName === this.ccRefundUndistributedCreditName
      || row.PaymentDistributionName === this.ccRefundUnappliedBalanceName);
  }

  // undistributed payment credit has no doctor of its own, so the user must pick one before refunding it
  requiresRefundDoctorSelection(): boolean {
    if (!this.isCreditCardRefundAction() || !this.paymentToRefund) {
      return false;
    }
    return this.paymentRecordsCC.some(a => a.PaymentID === this.paymentToRefund.PaymentID
      && this.isUndistributedCreditRow(a) && this.getNumber(a.Refund ?? 0) > 0);
  }

  private isNSFReason(): boolean {
    const id = this.selectedCreditDebitReason?.enumARReasonDebitAdjustmentID;
    return id === DEBIT_ADJUSTMENT_REASON.NSFFee || id === DEBIT_ADJUSTMENT_REASON.NSFCheckReversal;
  }

  private isDebitPatientAccountAction(): boolean {
    return this.selectedEnumDebitAdjustmentAction?.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount;
  }

  onReasonChange() {
    // Debit Patient Account: NSF and non-NSF reasons use different ledger item lists; drop a selection that is no longer valid
    const isNSF = this.isNSFReason();
    if (isNSF !== this.lastReasonWasNSF && this.selectedLedgerItem
      && this.isDebitPatientAccountAction() && this.type !== 'void-payment') {
      this.selectedLedgerItem = null;
      this.ledgerItemText = '';
    }
    this.lastReasonWasNSF = isNSF;
  }

  private getNSFAmountValidationMessage(): string | null {
    if (!this.isNSFReason() || !this.selectedLedgerItem || !this.isDebitPatientAccountAction()) {
      return null;
    }
    const maxAmount = Math.abs(this.getNumber(this.selectedLedgerItem.Amount ?? 0));
    if (this.getNumber(this.ledgerItem?.Amount ?? 0) > maxAmount) {
      return `Amount cannot be greater than the selected ledger item amount`;
    }
    return null;
  }

  onARAccountChange() {
    this.applyCreditCardRefundFooterMessage();
  }

  private applyCreditCardRefundFooterMessage(): void {
    if (this.selectedEnumDebitAdjustmentAction?.ValidValueItemId !== this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      return;
    }
    const msg = this.getCreditCardRefundValidationMessage();
    this.footerMessage = msg ?? '';
  }

  readyToSave(): boolean {

    if (this.type === 'credit') {
      return !!(this.selectedCreditDebitReason && this.selectedDate && this.ledgerItem.Amount && this.selectedCreditDebitReason.enumARReasonCreditAdjustmentID && this.selectedLocation && this.selectedARAccount);
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction &&
      this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      if (!(this.selectedCreditDebitReason && this.selectedDate && this.ledgerItem.Amount
        && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID && this.selectedLocation)) {
        return false;
      }
      return this.getCreditCardRefundValidationMessage() === null;
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      // quickbooks
      return !!(this.selectedCreditDebitReason && this.selectedDate && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID && this.selectedLocation);
    }
    else if (this.type === 'debit' && this.selectedEnumDebitAdjustmentAction && this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionDebitPatientAccount) {
      // debit patient account
      return !!(this.selectedCreditDebitReason && this.selectedDate && this.selectedCreditDebitReason.enumARReasonDebitAdjustmentID
        && this.selectedLocation && this.selectedARAccount && this.selectedLedgerItem);
    }
    else if (this.type === 'void-payment') {
      return !!(this.selectedDate && this.adjustmentNote && this.selectedCreditDebitReason);
    }
    else if (this.type === 'checkreversal') {
      return !!(this.selectedDate && this.adjustmentNote && this.selectedCreditDebitReason
        && this.selectedLocation && this.selectedARAccount);
    }
    return false;
  }

  onCreditRowSelected($event: TdoTableSelectionEvent) {
    this.selectedLedgerItem = $event.model;
  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }

  refundRowChecked(ledgerID: string, amount: number) {
    const checkedRow = this.ledgerItemsCredits.find(a => a.LedgerID === ledgerID);

    if (checkedRow?.RefundChecked) {
      // enforce single selection: uncheck every other credit row
      this.ledgerItemsCredits.forEach(a => {
        if (a.LedgerID !== ledgerID && a.RefundChecked) {
          a.RefundChecked = false;
          a.RefundAmount = 0;
        }
      });
      this.selectedLedgerItem = checkedRow;
    } else {
      this.selectedLedgerItem = null;
    }

    this.ledgerItemsCredits.forEach(a => {
      if (a.LedgerID === ledgerID && !a.RefundChecked) {
        a.RefundAmount = 0;
        amount = 0;
      }
    });

    this.updateTotalRefundAmount();

    // trigger change event
    this.raiseCustomEvent2('refundRow' + ledgerID, amount);
  }

  updateTotalRefundAmount() {
    let amount: number = 0;
    this.ledgerItemsCredits.forEach(a => {
      if (a.RefundChecked) {
        amount = ConversionUtilities.roundDecimal(amount + (this.getNumber(a.RefundAmount ?? 0) || 0));
      }
    });
    this.ledgerItem.Amount = amount;
    // trigger change event
    this.raiseCustomEvent2('debitAmount', this.ledgerItem.Amount);
  }

  raiseCustomEvent2(id: string, amount: number) {
    const evt = new CustomEvent('valChange', { detail: { amt: amount.toString() } });
    setTimeout(() => document.getElementById(id).dispatchEvent(evt), 200);
  }

  onUpdateRefundAmount(event, row: DataARLedgerListModel) {
    // set value
    let val: number = 0;
    if (event.target.value) {
      val = this.getNumber(event.target.value);
      if (!Number.isNaN(val) && val <= this.getNumber(row.Amount)) {
        row.RefundAmount = val;
      }
      else {
        row.RefundAmount = 0;
      }
    }

    // keep the input in currency format even when the model value did not change
    event.target.value = this.formatCurrency(row.RefundAmount);

    // model updated...
    this.updateTotalRefundAmount();
  }

  saveNote() {

    const mod = new TdoNoteSaveModel();
    mod.text = this.adjustmentNote;
    mod.patientId = this.globals.currentPatientId;

    const assoc = new TdoNoteAssociatedObject();
    assoc.objectId = this.ledgerItem.LedgerID;
    assoc.parentObjectName = 'dataARLedger';
    mod.associatedObjects = [];
    mod.associatedObjects.push(assoc);

    mod.categoryEnumIds = [NoteCategoryEnum.Ledger];
    mod.typeEnumIds = [NoteTypeEnum.Administartive];
    this.notesService.saveNote(mod).subscribe((res) => {
      this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
    });
  }

  createNoteForLedgerItem() {
    // add note for ledger item
    const model = new TdoNoteSaveModel();
    model.patientId = this.data.PatientId;
    model.text = this.adjustmentNote;

    const associatedObjects = [];
    const newAssociatedObject = new TdoNoteAssociatedObject();
    newAssociatedObject.objectId = this.ledgerItem.LedgerID;
    newAssociatedObject.parentObjectName = 'dataARLedger';
    associatedObjects.push(newAssociatedObject);

    model.associatedObjects = associatedObjects;
    model.categoryEnumIds.push(NoteCategoryEnum.Ledger);
    model.typeEnumIds.push(NoteTypeEnum.Administartive);
    model.typeEnumIds.push(NoteTypeEnum.Patient);
    this.messagingService.sendComponentMessage(MessagingConstants.NOTES_CREATE_NOTE, model);
  }

  openEditReasons(event: MouseEvent) {
    this.openContext(event, this.editReasonContextTemplate, null);
  }

  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
    this.closeContext();
    x = x + 100;
    y = y - 20;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  async openDebitCreditReasons() {
    const dialogRef = this.dialog.open(ArDebitCreditReasonsComponent, {
      width: '700px',
      height: '700px',
      panelClass: 'dialog',
      data: {
        reasonType: this.type
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // changes were saved
        // update reasons list
        this.loadReasons(true);
        if (!this.destroyed) { this.changeDetection.markForCheck(); }        
      }
    }, err => {
    });
  }

  async loadReasons(ignoreCache: boolean = false) {
    this.selectedARAccount = null;
    const promises: any[] = [
      lastValueFrom(this.arService.getDebitCreditReasons(this.LOCID, ignoreCache)),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.creditDebitReasons = results[0];
      this.filterCreditDebitReasonsByType();
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
    finally {
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
  }

  validateAmount(): boolean {

    this.footerMessage = '';
    if (this.ledgerItem.Amount <= 0 && !this.paymentToVoid) {
      this.footerMessage = 'Amount must be greater than 0';
      return false;
    }
    const nsfAmountMessage = this.getNSFAmountValidationMessage();
    if (nsfAmountMessage) {
      this.footerMessage = nsfAmountMessage;
      return false;
    }
    if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId !== this.enumDebitAdjustmentActionDebitPatientAccount && this.selectedEnumDebitAdjustmentAction.ValidValueItemId !== this.enumDebitAdjustmentActionIssueCheckInQuickBooks) {
      if (this.ledgerItem.Amount > this.paymentToRefund.AvailableAmount) {
        this.footerMessage = 'Refund must be less than or equal to the available amount';
        return false;
      }
    }
    return true;
  }

  onCCRefundRowContextMenu($event: MouseEvent, row) {

  }

  onCCRefundRowSelectedClick(row: CreditCardRefundablePaymentModel, event: MouseEvent) {
    // the checkbox and refund input handle their own clicks
    if ((event?.target as HTMLElement)?.closest('input, mat-checkbox, mat-form-field')) {
      return;
    }
    const parent = this.paymentRecordsCC.find(a => a.PaymentID === row.PaymentID && a.IsPayment);
    if (!parent || parent.isChecked) {
      return;
    }
    parent.isChecked = true;
    this.refundCCChecked(parent.PaymentID);
    if (!this.destroyed) { this.changeDetection.markForCheck(); }
  }

  onUpdateCCRefundAmount(event, element) {
    // set value
    // this.paymentRecordsCC.forEach(a => {
    //   if (a.PaymetnDistributionID === element.PaymetnDistributionID) {
    //     a.Refund = event.target.value;
    //   }
    // });
    let paymentRecord = this.paymentRecordsCC.find(a => a.PaymetnDistributionID === element.PaymetnDistributionID);
    if (paymentRecord) {
      paymentRecord.Refund = this.getNumber(event.target.value) || 0;
      // keep the input in currency format even when the model value did not change
      event.target.value = this.formatCurrency(paymentRecord.Refund);
    }

    // model updated...
    this.refreshCCRefundData();
    this.refreshCCRefundAmountToRefund();
  }

  CCRefundIsParentChecked(PaymentID: string) {
    let blReturn = false;
    this.paymentRecordsCC.forEach(a => {
      if (a.PaymentID === PaymentID && a.isChecked && a.IsPayment) {
        blReturn = true;
      }
    });
    return blReturn;
  }

  refundCCChecked(paymentId: string) {
    this.paymentRecordsCC.forEach(a => {
      if (a.PaymentID !== paymentId && a.isChecked && a.IsPayment) {
        a.isChecked = false;
      }
      else if (a.PaymentID === paymentId && a.isChecked && a.IsPayment) {
        this.paymentToRefund = a;
      }
      a.Refund = 0;
    });

    this.refreshCCRefundData();
    this.refreshCCRefundAmountToRefund();
    this.refreshSystemsIntegration();

    if (this.paymentToRefund?.isChecked) {
      this.LoadLocationAndARAccountForRefundPayment();
    }
  }

  // same as choosing a ledger item reference: default the location from the payment's ledger row,
  // reload that location's AR accounts and select the payment's doctor
  async LoadLocationAndARAccountForRefundPayment() {
    const payment = this.paymentToRefund;
    const paymentLedgerItem = this.ledgerItems.find(a => a.PaymetnID === payment.PaymentID && a.LOCID);
    const location = paymentLedgerItem
      ? this.locations.find(a => Number(a.LOCID) === Number(paymentLedgerItem.LOCID))
      : null;
    if (location) {
      this.selectedLocation = location;
      const applied = await this.onLocationChange();
      // selection may have changed while accounts were loading
      if (!applied || this.paymentToRefund !== payment || !payment.isChecked) {
        return;
      }
    }

    const doctorARLocId = this.isValidGuid(payment.DoctorARLocId)
      ? payment.DoctorARLocId
      : this.ledgerItems.find(a => a.PaymetnID === payment.PaymentID && this.isValidGuid(a.DoctorARLocId))?.DoctorARLocId;
    this.selectedARAccount = this.isValidGuid(doctorARLocId)
      ? this.arAccounts.find(a => a.DoctorARLocId === doctorARLocId) ?? null
      : null;

    this.applyCreditCardRefundFooterMessage();
    if (!this.destroyed) { this.changeDetection.markForCheck(); }
  }

  async refreshSystemsIntegration() {
    const payment = this.paymentToRefund;
    const location = this.selectedLocation;
    if (!payment?.isChecked || !payment.DoctorID || !location?.LOCID) {
      this.isDoctorARQuickBooksIntegration = false;
      return;
    }
    try {
      const integration = await this.getDoctorARLocationIntegration(Number.parseInt(location.LOCID), payment.DoctorID);
      // payment or location may have changed while the request was in flight
      if (this.paymentToRefund !== payment || this.selectedLocation !== location || !payment.isChecked) {
        return;
      }
      this.isDoctorARQuickBooksIntegration = integration == ArIntegration_QuickBooks;
    }
    catch (err) {
      console.log(err);
      this.displayMessage('Something went wrong', 'Error');
    }
    finally {
      if (!this.destroyed) { this.changeDetection.markForCheck(); }
    }
  }

  refreshCCRefundData() {
    this.ccRefundTable.dataSource = this.paymentRecordsCC;
  }

  refreshCCRefundAmountToRefund() {
    this.footerMessage = '';
    let refundAmount = 0;
    if (this.selectedEnumDebitAdjustmentAction.ValidValueItemId === this.enumDebitAdjustmentActionIssueCreditCardRefund) {
      this.paymentRecordsCC.forEach(a => {
        if (a.IsDistribution && this.CCRefundIsParentChecked(a.PaymentID)) {
          refundAmount = ConversionUtilities.roundDecimal(refundAmount + Number.parseFloat(a.Refund.toString().replace('$', '')));
        }
      });
    }
    this.ledgerItem.Amount = refundAmount;
    this.CCRefundAmountToRefund = refundAmount;
    this.raiseCustomEvent2('debitAmount', refundAmount);

    this.applyCreditCardRefundFooterMessage();
    return refundAmount;
  }

  getNumber(value) {
    return ConversionUtilities.roundDecimal(Number.parseFloat(value.toString().replace(/[$,]/g, '')));
  }

  formatCurrency(value) {
    return this.currencyPipe.transform(value ?? 0, 'USD', 'symbol', '1.2-2');
  }
}
